// Webpack Imports
import * as bootstrap from 'bootstrap';

( function () {
	'use strict';

	// feather icons init
	feather.replace();

	if($('#page-header-slider').length>0){
		$('#page-header-slider').slick({
			arrows : false,
			dots : true,
		});
	}

	if($('#partners-slider').length>0){
		$('#partners-slider').slick({
			arrows : true,
			infinite: true,
			autoplay:true,
			slidesToShow: 5,
			slidesToScroll: 1,
			responsive: [
				{
				  breakpoint: 992,
				  settings: {
					slidesToShow: 4,
				  }
				},
				{
				  breakpoint: 768,
				  settings: {
					slidesToShow: 3
				  }
				},
				{
				  breakpoint: 576,
				  settings: {
					slidesToShow: 2
				  }
				}
			]
		});
	}

	if($('#products-slider').length>0){
		$('#products-slider').slick({
			arrows : false,
			infinite:false,
			slidesToShow: 4,
			slidesToScroll: 1,
			responsive: [
				{
				  breakpoint: 1024,
				  settings: {
					slidesToShow: 3,
				  }
				},
				{
				  breakpoint: 992,
				  settings: {
					slidesToShow: 2
				  }
				},
				{
				  breakpoint: 576,
				  settings: {
					slidesToShow: 1
				  }
				}
			]
		});
	}

	if($('#gallery').length>0){
		$("#gallery").justifiedGallery({
			rowHeight: 250,
			margins : 15
		})
		$('#gallery').lightGallery({
			thumbnail:true,
			mode: 'lg-fade',
			fullScreen:false,
			download:false,
			hash:false
		});
	}

	if($('#works-slider').length>0){
		$('#works-slider').on('init', function(){
			$(this).lightGallery({
				selector : '.lightgallery-item',
				thumbnail:true,
				mode: 'lg-fade',
				fullScreen:false,
				download:false,
				hash:false
			});
		});

		$('#works-slider').slick({
			arrows : true,
			infinite:true,
			slidesToShow: 4,
			slidesToScroll: 1,
			responsive: [
				{
				  breakpoint: 1024,
				  settings: {
					slidesToShow: 3,
				  }
				},
				{
				  breakpoint: 992,
				  settings: {
					slidesToShow: 2
				  }
				},
				{
				  breakpoint: 576,
				  settings: {
					slidesToShow: 1
				  }
				}
			],
		})
	}

	
} )();